import React from 'react';
import { addEvent, removeEvent, event } from 'skin/event';
import ok from 'skin/space';
import login from 'skin/entry/login';
import signup from 'skin/entry/signup';
import reset from 'skin/entry/reset';
import partner from 'skin/entry/partner';
import wait from 'skin/wait';
import state from './state';

const def = { ok, login, signup, reset, partner };
class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = state;
		this.event = this.event.bind(this);
	}
	render() {
		return this.page();
	}
	// Определить что показывать изначально
	page() {
		const Cmp = def[this.state.type] ?? wait;
		return <Cmp data={this.state} />;
	}

	event(e) {
		const o = e.detail;
		event(this, o);
	}

	componentDidMount() {
		addEvent(this);
	}
	componentWillUnmount() {
		removeEvent(this);
	}
}

export default App;
